<template>
  <div>
    <vx-card no-shadow>
      <div id="subscriptionsPackageLoadingDiv" class="vs-con-loading__container">
        <div class="vx-row">
          <div class="vx-col w-full w-full mb-5">
            <vs-table :data="subscriptions" v-if="subscriptions.length">
              <template slot="thead">
                <vs-th>Name</vs-th>
                <vs-th>Start Date</vs-th>
                <vs-th>End Date</vs-th>
                <vs-th>Amount</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td :data="data[indextr].admin_package_name">
                    {{data[indextr].admin_package_name}}
                  </vs-td>
                  <vs-td :data="data[indextr].start_date">
                    {{data[indextr].start_date}}
                  </vs-td>
                  <vs-td :data="data[indextr].expiry_date">
                    {{data[indextr].expiry_date}}
                  </vs-td>
                  <vs-td :data="data[indextr].amount">
                    {{data[indextr].amount}} DKK
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>

            <vs-alert color="danger" title="Not Found" v-else>
              <span>No subscriptions available for this request.</span>
            </vs-alert>
          </div>
        </div>

        <div class="vx-row">
          <div v-for="(product, productIndex) in products" class="vx-col w-1/4">
            <vx-card>
              <h5 class="mb-2">{{ product.name }}</h5>
              <p class="text-grey">Price {{ product.cost }}</p>
              <p class="text-grey">{{ product.description }}</p>
              <div class="flex justify-between flex-wrap">
                <vs-button :disabled="getCurrentProductButtonStatus(product)" @click="getSubscriptionLink(product)"class="mt-4 mr-2 shadow-lg w-full" type="gradient" color="primary"  icon-pack="feather" icon="icon-menu" icon-after>{{ getCurrentProductStatusName(product) }}</vs-button>
              </div>
            </vx-card>
          </div>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import moduleClubManagement from '@/store/club-management/moduleClubManagement.js'

export default {
  data() {
    return {

    }
  },
  methods: {
    getCurrentProductButtonStatus(product) {
      return  this.getCurrentProductStatus(product)
    },
    getCurrentProductStatusName(product) {
      let status = this.getCurrentProductStatus(product)
      return (status == true) ? "Current Product" : "Buy Now";
    },
    getCurrentProductStatus(product) {
      var isFound = []
      if(this.subscriptions.length){
        isFound = this.subscriptions.filter(obj => { return obj.admin_package_id == product.id}) 
      }

      return (isFound.length) ? true : false
    },
    getSubscriptionLink(product) {
      this.$vs.loading({
        container: '#subscriptionsPackageLoadingDiv',
        scale: 0.6
      })

      let data = { 
        package_id : product.id,
        redirect_url : window.location.href
      }

      this.$store.dispatch("clubManagement/getSubscriptionLink", data)
        .then(res => { 
          this.$vs.loading.close('#subscriptionsPackageLoadingDiv > .con-vs-loading')

          if(res.data && res.data.quickpay_subscription_url){
            window.location.href = res.data.quickpay_subscription_url;
          }
        })
        .catch(err => { 
          this.$vs.loading.close('#subscriptionsPackageLoadingDiv > .con-vs-loading')
        })
    },
    async checkSubscriptionId(subscriptionId, productId) {
      await this.$store.dispatch("clubManagement/getSubscriptions")

      this.$vs.loading({
        container: '#subscriptionsPackageLoadingDiv',
        scale: 0.6
      })

      var apiName = (this.subscriptions.length) ? "clubManagement/changeProduct" : "clubManagement/newProduct"

      let data = {
        package_id : productId,
        subscription_id : subscriptionId, 
      }

      await this.$store.dispatch(apiName, data)
        .then(res => { 
          if(res.status && res.status == 201){
            this.$vs.notify({
              time:4000,
              title:'Success',
              text: (res.data.status_message) ? res.data.status_message : 'Sussfully Paid.',
              color:'success',
              iconPack: 'feather',
              icon:'icon-alert-circle'
            });
          }

          this.$store.dispatch("clubManagement/getSubscriptions")
          this.$vs.loading.close('#subscriptionsPackageLoadingDiv > .con-vs-loading')
          this.$router.push("/subscription").catch(() => {})
        })
        .catch(err => { 
          this.$vs.loading.close('#subscriptionsPackageLoadingDiv > .con-vs-loading')
        })
    },
    getClubData() {
      this.$store.dispatch("clubManagement/getClubData")
        .then(res => { })
        .catch(err => { })
    },
  },
  computed: {
    products() {
      return this.$store.state.clubManagement.products
    },
    subscriptions() {
      return this.$store.state.clubManagement.subscriptions
    },
    isSmallerScreen() {
      return this.$store.state.windowWidth < 768
    }
  },
  created() {
    if(!moduleClubManagement.isRegistered) {
        this.$store.registerModule('clubManagement', moduleClubManagement)
        moduleClubManagement.isRegistered = true
    }

    this.$store.dispatch("clubManagement/getSubscriptions")
    this.$store.dispatch("clubManagement/getProducts")
  },
  mounted(){
    var productId = null
    var subscriptionId = null
    let uri = window.location.search.substring(1); 
    let params = new URLSearchParams(uri);
    productId = params.get("product_id");
    subscriptionId = params.get("subscription_id");
    
    if(subscriptionId && productId){
      this.checkSubscriptionId(subscriptionId, productId)
    }
  }
}
</script>

<style lang="scss">
#profile-tabs {
  .vs-tabs--content {
    padding: 0;
  }
}
</style>